import React from "react";
import ReactDOM from "react-dom";

import "./i18n";
import "./index.css";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from "./ErrorBoundary";

import "lib/firebase-provider/firebaseApp";
import firebase from "firebase/app";

if (process.env.NODE_ENV !== "development") {
  firebase.analytics();
}

if (process.env.NODE_ENV === "development") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React, {
    trackAllPureComponents: false,
  });
}

ReactDOM.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  /* </React.StrictMode>, */ document.getElementById("root")
);

serviceWorker.unregister();
